import { formatCTAS, formatRichText, formatTiles } from "../../functions";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import DefaultInfoCard from "../../components/InfoCards/DefaultInfoCard";
import { ConditionCardItem } from "../../../views/UIelems/v2/conditionsCards/ConditionCardItem";
import { DoctorImage } from "./DoctorImage";
import { CTAWrapper } from "../../components/CTA";
import { parseClassesIntoHtml } from "../../functions/styling";

const INFO_CLASSES = {
	p: 'text-black text-base [&_a]:no-underline [&_a]:!text-is2-blue-500',
}

const SECONDARY_INFO_CLASSES = {
	p: 'text-is2-gray-150 text-base [&_a]:no-underline [&_a]:!text-is2-blue-500',
}
const formatInformationContent = (description, tiles, ctas, descriptionStyling, siteStatus, secondaryDescription) => {
	const formattedTiles = formatTiles(tiles, siteStatus);
	const formattedCTAs = formatCTAS(ctas, siteStatus, true);
	const content = formatRichText(description, siteStatus);
	const secondaryContent = secondaryDescription ? formatRichText(secondaryDescription, siteStatus) : null;
	return (
		<div>
			{description && (
				<div
					className={`flex flex-col gap-4 mt-4 text-sm [&_a]:no-underline [&_a]:!text-is2-blue-500 ${descriptionStyling}`}
				>
					{parseClassesIntoHtml(INFO_CLASSES, content)}
				</div>
			)}
			{formattedTiles?.length > 0 && (
				<div
					className="
          mt-6
          grid
          grid-cols-2
          gap-4
          lg:grid-cols-[repeat(auto-fit,minmax(90px,1fr))]
          lg:gap-6
          lg:grid-flow-col
          lg:auto-cols-fr
          justify-between
        "
				>
					{formattedTiles?.map((tile, index) => (
						<div key={`${tile.title}-${index}`} className="flex justify-center">
							<ConditionCardItem {...tile} isIcon={true} />
						</div>
					))}
				</div>
			)}

			{formattedCTAs?.length > 0 && (
				<div className="flex flex-col md:flex-row justify-center items-center gap-4 mt-8 w-full">
					{formattedCTAs.map((cta, index) => (
						<CTAWrapper key={index} cta={cta} />
					))}
				</div>
			)}

			{secondaryContent && (
				<div className={`flex flex-col gap-4 mt-12 text-sm [&_a]:no-underline [&_a]:!text-is2-blue-500 ${descriptionStyling}`}>
					{parseClassesIntoHtml(SECONDARY_INFO_CLASSES, secondaryContent)}
				</div>
			)}
		</div>
	);
};

export const DoctorAdaptiveContent = ({
	title,
	headerText,
	subtitle,
	image,
	imageSignature,
	description,
	variant,
	tiles = null,
	imageFooter = null,
	footerBackgroundColor,
	formattedSectionStyles = {},
	ctas = [],
	siteStatus = {},
	imageOnLeft = false,
	secondaryDescription = null,
	exp
}) => {
	const doctorImage = (
		<DoctorImage
			image={image}
			title={title}
			imageSignature={imageSignature}
			imageFooter={imageFooter}
			footerBackgroundColor={footerBackgroundColor}
			siteStatus={siteStatus}
		/>
	);

	const formattedInformationContent = formatInformationContent(
		description,
		tiles,
		ctas,
		formattedSectionStyles.descriptionStyling,
		siteStatus,
		secondaryDescription,
	);

	const cardStyling = {
		...formattedSectionStyles,
		cardStyling: {
			backgroundColor: formattedSectionStyles.wrapperColor || formattedSectionStyles?.inverseColor,
		},
	};
	return (
		<PageSectionWrapper variant={variant ?? "normal"}>
			<DefaultInfoCard
				imageComponent={doctorImage}
				subtitle={subtitle}
				headerText={headerText}
				content={exp ? description : formattedInformationContent}
				isEven={!imageOnLeft}
				formattedSectionStyles={cardStyling}
				imageWrapperStyling="md:basis-6/12"
			/>
		</PageSectionWrapper>
	);
};
